import {commentAxios} from "../commentAxios";

export const complainOnComment = (commentId) => {
    return commentAxios.post('/comments/complaint', {
        commentId: commentId
    });
};
